import React, { useContext, useRef, useState } from 'react' 
import { useSelector } from 'react-redux';
import ChatModule from '../common/chat/chat';
import { OtsideClickClosingWrapper } from '../common/EmojiReactionPicker/OtsideClickClosingWrapper';
import AppContext from '../Context/AppContext';
import { canAccess } from '../common/util/appUtils';
import { message } from 'antd';

export default function ChatSection() {
  const accessContext = useSelector(state => state.UserContext.accessContext);
  const AllNotificationsForChat = useSelector((state) => state.AppReduxContext.AllNotificationsForChat);
  const {dispatch, state} = useContext(AppContext) || {};
  const [openChatModal, setOpenChatModal] = useState(false);
  const chatButtonRef = useRef();
  const [loader, setLoader] = useState(false);
  const [refreshTheChat,setRefreshChat] = useState(false);

  const displayNotificationForChat = (messages) => {
    let items=[];
    messages?.forEach((message,i)=>{
      message=message?.Notifications || message;
      if (
        message?.Type == "Mention" ||
        message?.Type == "Message" || message?.Type=="Attachment"
      ) {
        items.push (message);
      }
    }) 
    return (<div
            ref={chatButtonRef}
            id="ChatOpenFromServiceWorker"
            onClick={() =>{
              if(!canAccess(accessContext, "Chats", "View")){message.error("Permission Denied"); return}
                setOpenChatModal(!openChatModal)}
            } 
            className="chat-box"
          >
            <i className="fa fa-comment"></i> <span>Chat</span>
            {items?.length > 0 ? (
              <span className="badge badge-light">
                {items?.length}
              </span>
            ) : (
              <></>
            )}
          </div>) 
  };
 
  return (
    <div style={{position: 'fixed',bottom: '2px',right: '6px', zIndex: 10000,display: 'flex',alignItems: 'center'}}>
        {AllNotificationsForChat && displayNotificationForChat(AllNotificationsForChat)} 
                      {openChatModal ? (
                        <OtsideClickClosingWrapper
                          className="Chat-Module-Wrapper"
                          fromListViewOfTasks={true}
                          close={e=>{
                            setOpenChatModal(false);
                          }}
                        >
                            <ChatModule
                            loader={loader}
                            refreshTheChat={refreshTheChat}
                            setRefreshChat={setRefreshChat}
                            setLoader={setLoader}  
                            allUsers={state.AllAppUsers}
                            chatButtonRef={chatButtonRef}
                            notifyUser={null} //  <--- Updated from notifyUser state which was removed and default null
                            handleOutsideClick={() => setOpenChatModal(!openChatModal)}
                          />
                        </OtsideClickClosingWrapper> 
                      ) : (
                        <></>
                      )}
    </div>
  )
}
